import Chart from 'chart.js/auto';

// Line Graph Defaults
Chart.defaults.elements.line.tension = 0.5;
Chart.defaults.elements.line.borderWidth = 3;
Chart.defaults.elements.line.borderColor = 'rgba(255,99,132,1)';

// Don't show points
Chart.defaults.elements.point.radius = 0;

// Don't show grid lines
Chart.defaults.scale.grid.display = false;
